import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs/Subscription';

import { Account, Faculty } from '../../../models';
import { FacultyService, Principal } from '../../../services';
import { FileUtils } from '../../../shared';
import { FACULTY_LIST_MODIFICATION } from '../../../shared/constants';

@Component({
    selector: 'qms-faculties',
    templateUrl: './faculties.component.html'
})
export class FacultiesComponent implements OnInit, OnDestroy {

    public faculties: Faculty[];

    private currentAccount: Account;
    private eventSubscription: Subscription;

    constructor(private facultyService: FacultyService,
                private principal: Principal,
                private eventManager: JhiEventManager) {
    }

    private loadAll() {
        this.facultyService.all().subscribe((response: Faculty[]) => {
            this.faculties = response;
        });
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.loadAll();
        this.registerChangeInFaculties();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscription);
    }

    public trackId(index: number, item: Faculty) {
        return item.id;
    }

    public getLogo(faculty: Faculty) {
        return FileUtils.getImageBase64Format(faculty.logo, faculty.logoContentType);
    }

    private registerChangeInFaculties() {
        this.eventSubscription = this.eventManager.subscribe(FACULTY_LIST_MODIFICATION, (response) => {
            this.principal.identity(true); // Reload user after faculties modification
            this.loadAll();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/faculties/faculties.component.ts